export default __webpack_public_path__ + "static/media/ES.472f7f3a.svg";